<template>
  <div class="assay-view panel-sections edge-to-edge">
    <component :is="typeComponent" :dv="dv" />
    <EntityOwnership
      v-if="!dv.hideOwnershipLifecycle"
      :dv="dv"
      :collapsed="!dv.isEditing"
    />
    <EntitySharing v-if="!dv.hideSharing" :dv="dv" :collapsed="!dv.isEditing" />
  </div>
</template>

<script>
import { computed } from 'vue'

import EntityOwnership from '../shared/EntityOwnership.vue'
import EntitySharing from '../shared/EntitySharing.vue'
import AssayTransmissionEM from './electron-microscopy/AssayTransmissionEM.vue'
import AssayVolumeEM from './electron-microscopy/AssayVolumeEM.vue'
import GenericAssay from './GenericAssay.vue'
import AssayLightMicroscopy from './light-microscopy/AssayLightMicroscopy.vue'
import AssayLightMicroscopyScreen from './light-microscopy/AssayLightMicroscopyScreen.vue'
import AssaySequencing from './sequencing/AssaySequencing.vue'

// Dispatcher for assay detail views. Selects a type-specific component based
// on dv.modelType (e.g. AssaySequencing, AssayLightMicroscopy) and falls back
// to GenericAssay for all other types. Each type component owns its own field
// layout and passes it to the shared AssayDescriptionGrid. EntitySharing and
// EntityOwnership are rendered outside the type component so they appear
// consistently for every assay type.
export default {
  name: 'AssayView',
  components: {
    EntitySharing,
    EntityOwnership,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const modelType = computed(() => (props.dv.modelType || '').toLowerCase())

    const typeComponent = computed(() => {
      switch (modelType.value) {
        case 'ngsilluminaassay':
        case 'avitisequencingassay':
        case 'nanoporeassay':
          return AssaySequencing
        case 'lightmicroscopyassay':
          return AssayLightMicroscopy
        case 'lightmicroscopyscreenassay':
          return AssayLightMicroscopyScreen
        case 'volumeemassay':
          return AssayVolumeEM
        case 'transmissionemassay':
          return AssayTransmissionEM
        default:
          return GenericAssay
      }
    })

    return { typeComponent }
  },
}
</script>
